/**
 * Show the current slide number under the slider.
 *
 * @param {object} Splide Current Splide instance reference.
 * @param {object} Components Current Splide components.
 * @returns {object} Splide component.
 */
function SlideNumber( Splide, Components ) {
	const { root } = Components.Elements;

	let elm;

	const mount = () => {
		elm = document.createElement( 'div' );
		elm.className = 'kaplan-carousel__counter';

		root.parentElement.insertBefore( elm, root.nextSibling );

		update();
		Splide.on( 'move', update );
		Splide.on( 'destroy', remove );
	};

	const update = () => {
		elm.textContent = `${ Splide.index + 1 }/${ Splide.length }`;
	};

	const remove = () => {
		elm.remove();
	};

	return {
		mount,
	};
}

export default SlideNumber;
